import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-highlight',
  templateUrl: './highlight.component.html',
  styleUrls: ['./highlight.component.scss']
})
export class HighlightComponent implements OnInit {

  selectedItem: any = null;

  facilities = [
    {
      title: 'Medical',
      icon: 'fa-solid fa-briefcase-medical',
      colorClass: 'gradient-blue',
      description: 'The School has a neat and clean Medical room for First aid purposes. The School is associated with a reputed nearby hospital. If there is any medical issue beyond the first-aid provision available in the medical room of the school premises, the school takes the child to the associated hospital for immediate required Medical care/treatment.'
    },
    {
      title: 'Digital Classrooms',
      icon: 'fa-solid fa-chalkboard-user',
      colorClass: 'gradient-purple',
      description: 'Smart Classroom is a comprehensive strategy for digital education in Aryakulam International School – All Smart Classrooms are supported by EXTRAMARKS.COM that makes Education Easy, Effortless, and Activity oriented. The approach of learning is through a new Layered, Scientific & Strategic process.'
    },
    {
      title: 'Library',
      icon: 'fa-solid fa-book-open-reader',
      colorClass: 'gradient-orange',
      description: 'The school has a spacious and ultra modern Library with a wide range of books on all subjects. The school library is visited regularly by all students. It has an impressive collection of academic and reference books, as well as journals and periodicals. To improve students’ vocabulary and broaden their horizons, the library also has a wide selection of fiction books.'
    },
    {
      title: 'Computer Lab',
      icon: 'fa-solid fa-computer',
      colorClass: 'gradient-green',
      description: 'We have THREE Computer Labs (1 Junior level, 2 Senior level) equipped with machines having latest configuration for providing hands on experience to students from I to XII. There are over 110 computers to help students to give thorough knowledge about the subject. All the computers are connected via Local Area Network.'
    },
    {
      title: 'Science Labs',
      icon: 'fa-solid fa-flask',
      colorClass: 'gradient-red',
      description: 'Science is a natural and fundamental base of our life. It helps students in understanding the existence of world around them. In order to achieve this aim and understanding the concepts of science, the school has well equipped laboratories Physics, Chemistry and Biology with latest facilities, apparatus and other required equipments.'
    },
    {
      title: 'AV Room',
      icon: 'fa-solid fa-tv',
      colorClass: 'gradient-teal',
      description: 'Our School has a well-equipped and furnished, fully Air Conditioned Audio Visual Room. The main purpose of having this multimedia experience for students is the fact that whatever is seen by our eyes is retained by the brain more effectively than just reading or listening to it. Latest techniques such as Multimedia HD Projector, Digital cameras, Latest Configured PC with High Quality Sound System are being employed here.'
    },
    {
      title: 'Other Labs',
      icon: 'fa-solid fa-vials',
      colorClass: 'gradient-pink',
      description: 'Home Science Lab, Maths Lab, Art Room, Music Room, Hindi Lab'
    }
  ];

  constructor() { }

  ngOnInit(): void {
    this.selectedItem = this.facilities[0]; // Set default
  }

  setActive(facility: any) {
    this.selectedItem = facility;
  }
}
